import { render } from "./Frameworks.vue?vue&type=template&id=0fe6578c"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"static/js/components-wa/content/Frameworks.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0fe6578c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0fe6578c', __exports__)) {
    api.reload('0fe6578c', __exports__)
  }
  
  module.hot.accept("./Frameworks.vue?vue&type=template&id=0fe6578c", () => {
    api.rerender('0fe6578c', render)
  })

}


export default __exports__